import { Component, createRef } from 'react';
import { GoogleMap, MarkerF, InfoWindow, Autocomplete } from '@react-google-maps/api';
import { MarkerClusterer, SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import { Checkbox } from "@progress/kendo-react-inputs";
import ExpandedUGPole from "../../global_components/ug_pole_popup";
import ExpandedUGStreetViewPole from "../../global_components/ug_pole_streetview_popup.js";
import loadinggif from "../../assets/loading.gif";
import loadingtext from "../../assets/loadingmaps.png";
import withProject from "../../contexts/class_context_convert.js";
import withTabContext from "../../contexts/report_tab_context_convert.js";
import withHighlightedPoles from "../../contexts/highlighted_poles_class_context_convert.js";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import othersIcon from "../../assets/SymbologyIcons/selectedBlack.png";
import noaccess from "../../assets/images/noaccess.png";
import PIGreen from "../../assets/SymbologyIcons/PIGreen_Circle.png";
import PIRed from "../../assets/SymbologyIcons/PIRed_Circle.png";
import PIYellow from "../../assets/SymbologyIcons/PIYellow_Circle.png";
import PIBlack from "../../assets/SymbologyIcons/PIBlack_Circle.png";
import PRAudited from "../../assets/SymbologyIcons/PRAudited.png";
import PRNotAudited from "../../assets/SymbologyIcons/PRNotAudited_UG.png";
import UGInspected from "../../assets/SymbologyIcons/UGInspected.png";
import UGNotInspected from "../../assets/SymbologyIcons/UGNotInspected.png";
import UGRejected from "../../assets/SymbologyIcons/UGRejected.png";
import { xIcon, plusIcon, minusIcon } from "@progress/kendo-svg-icons";
import moment from 'moment'
import { Button } from "@progress/kendo-react-buttons";
import withEnvironmentConfig from '../../contexts/EnvironmentConfigContextClassWrapper';
import addressIcon from "../../assets/SymbologyIcons/searchAddressCenterIcon.png";
import validationIcon from "../../assets/SymbologyIcons/ValidationIcon.png";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import getClusterRenderer from '../../global_components/getClusterRenderer.js';
import { debounce, generateIconWithLabel, reverseGeocodeAddress, teleportAndLookAtMarker } from '../../utils';

const containerStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '10px',
    borderColor: '#BFBFBF',
}

const containerStyleFullSize = {
    width: '100%',
    height: '81vh',
    borderRadius: '10px',
    borderColor: '#BFBFBF'
}
const clusterStyles = {
    "not-inspected": getClusterRenderer(),
    "inspected": getClusterRenderer('rgba(72, 142, 58, 1)'),
    "non-restorable-rejects": getClusterRenderer('rgba(211, 6, 6, 1)'),
    "restorable-rejects": getClusterRenderer('rgba(255, 197, 23, 1)'),
    "non-audited": getClusterRenderer('rgba(55, 55, 55, 1)'),
    "audited": getClusterRenderer('rgba(126, 212, 108, 1)'),
    "not-inspected-ug": getClusterRenderer(),
    "inspected-ug": getClusterRenderer('rgba(72, 142, 58, 1)'),
    "rejected-ug": getClusterRenderer('rgba(211, 6, 6, 1)'),
    "others": getClusterRenderer(),
};

const mapSearchOption = ['Structure ID', 'Address'];

const getStructureLabel = (structureType) => {
    if (!structureType) return "";
    
    const labels = {
        "Light": "L",
        "Vault": "V",
        "Pedestal": "P",
        "JBox": "J",
        "Switch Gear": "G",
        "Hand Hole": "H",
        "Three Phase Transformer": "3T",
        "Single Phase Transformer": "1T",
        "Three-Phase Transformer": "3T",
        "Single-Phase Transformer": "1T"
    };
    return labels[structureType] || ""; 
};

class RSPoleMap extends Component {
    firstTime = true;
    coverageLayer = null;
    geocoder = null;
    streetViewRef = createRef();
    streetViewMarkers = [];

    constructor(props) {
        super(props);
        this.state = {
            mapData: [],
            currentSelectedPole: null,
            currentCenter: {
                lat: 39.87597539,
                lng: -86.06844941
            },
            showPIInspected: true,
            showPINonRestorableRejects: true,
            showPINotInspected: true,
            showPIRestorableRejects: true,
            showPRAudited: true,
            showPRNotAudited: true,
            showUGInspected: true,
            showUGNotInspected: true,
            showUGRejects: true,
            showOthers: true,
            showAudited: true,
            showNotAudited: true,
            //START MAP DATA
            filteredMapData: [],
            //END MAP DATA
            showInfoWindow: true,
            checkedMaplegend: "No Status",
            originalData: null,
            showDrawer: true,
            currentPin: "default",
            legendLoading: true,
            loading: true,
            map: {},
            poleadderList: [],
            poleconditionList: [],
            poleauditstatusList: [],
            rawQuery: null,
            created_user: [],
            Reject_Status: [],
            created_user_checkbox: true,
            Reject_Status_checkbox: true,
            checkboxvalue: false,
            nodata: false,
            dateStart: null,
            dateEnd: null,
            showDate: {},
            counts: 0,
            drawingRec: null,
            lassoWindow: false,
            lassoData: null,
            drawOption: null,
            datevalue: null,
            audit_checkbox: true,
            zoomLevel: 16,
            box: {},
            isrecenter: false,
            searchType: "Structure ID",
            isSearchByAddress: false,
            addressValid: true,
            showErrorMessage: false,
            searchEnteredAddress: "",
            // Streetview
            currentAddress: null,
            currentCity: null,
            currentStreetViewSelectedPole: null,
            isStreetView: false,
            showStreetviewPoleMenu: false,
        };
        this.autocomplete = null;
        this.onLoad = this.onLoad.bind(this);
        this.onPlaceChanged = this.onPlaceChanged.bind(this);
        this.handleMarkerOnClick = this.handleMarkerOnClick.bind(this);
        this.handleMapOnClick = this.handleMapOnClick.bind(this);
        this.handlePoleonChange = this.handlePoleonChange.bind(this);
        this.wrapperRef = createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.notInspectedPIClusterer = null;
        this.inspectedPIClusterer = null;
        this.nonRestorableRejectsPIClusterer = null;
        this.restorableRejectsPIClusterer = null;
        this.auditedPRClusterer = null;
        this.notAuditedPRClusterer = null;
        this.inspectedUGClusterer = null;
        this.notInspectedUGClusterer = null;
        this.rejectedUGClusterer = null;
        this.othersClusterer = null;
    }

    componentDidMount() {
        if (this.props.projectContext.selectedProject !== "") {
            this.populateMapData("");
        }
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps) {
        if (this.props.projectContext.selectedProject !== prevProps.projectContext.selectedProject) {
            this.setState({ nodata: false, loading: true }, () => {
                this.populateMapData(""); 
                this.handleClearMapFilter(); 
            });
        }
    }

    handleClickOutside(event) {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
        this.setState({ showErrorMessage: false });
        }
    }

    handleAddressKeyPress(e) {
        if (e.key === 'Enter') {
            var searchInput = e.target.value;
            if (!this.state.map || !searchInput) return;

            this.geocoder.geocode({ address: String(searchInput) }, (results, status) => {
                if (status === "OK") {
                    this.setState({
                        currentCenter: results[0].geometry.location,
                        currentSelectedPole: null,
                        isSearchByAddress: true,
                        addressValid: true,
                        showErrorMessage: false
                    });
                }
                else {
                    this.setState({
                        addressValid: false,
                        searchEnteredAddress: searchInput,
                        isSearchByAddress: false,
                    });
                }
            });
            this.boundsCallBack();
        }
    }

    handleStreetviewKeyPress(e) {
        if (e.key !== 'Enter') return;
        
        var searchInput = e.target.value;
        var lookupData = this.state.mapData;

        if (searchInput === "") return;

        const foundPole = lookupData.find((data) => {
            if (!data || !data?.info) return false;
            return data.info.StructureID === searchInput;
        });

        if (!foundPole) return;

        const markerLocation = foundPole.coords;

        this.setState({
            currentStreetViewSelectedPole: null,
            zoomLevel: null,
            isSearchByAddress: false,
            currentCenter: null
        }, () => {
            this.setState({
                currentStreetViewSelectedPole: foundPole,
                zoomLevel : 16,
                currentCenter: markerLocation,
                isrecenter: !this.state.isrecenter,
                showStreetviewPoleMenu: true,
            }, () => {
                teleportAndLookAtMarker(this.panoramaInstance, markerLocation);
            });
        });
    }

    handleStreetviewAddressKeyPress(e) {
        if (e.key === 'Enter') {
            var searchInput = e.target.value;
            if (!this.state.map || !searchInput) return;

            this.geocoder.geocode({ address: String(searchInput) }, (results, status) => {
                if (status === "OK") {
                    const markerLocation = results[0].geometry.location;
                    this.setState({
                        currentCenter: markerLocation,
                        currentSelectedPole: null,
                        addressValid: true,
                        showErrorMessage: false
                    }, () => {
                        teleportAndLookAtMarker(this.panoramaInstance, markerLocation);
                    });
                }
                else {
                    this.setState({
                        addressValid: false,
                        searchEnteredAddress: searchInput,
                    });
                }
            });
        }
    }

    onPlaceChanged() {
        //251-B110
        if (this.autocomplete !== null) {
            var searchCallback = this.autocomplete.getPlace();
            if (searchCallback.geometry?.viewport) {
                this.setState({
                    currentCenter: searchCallback.geometry.location,
                    currentSelectedPole: null,
                    isSearchByAddress: true,
                    addressValid: true,
                    showErrorMessage: false
                });
            }
            else {
                this.setState({
                    isSearchByAddress: false,
                    addressValid: false,
                });
            }
        } else {
            console.log('Autocomplete is not loaded yet!')
            this.setState({
                isSearchByAddress: false,
            });
        }
        this.boundsCallBack();

    }

    handleSearchTypeChange(e) {
        var value = e.target.value;
        console.log(value);
        this.setState({
            searchType: value,
            addressValid: true,
            isSearchByAddress: false,
            showErrorMessage: false
        })
    }

    handlePoleonChange(e, type, pinType) {
        if (type === this.state.checkedMaplegend) {
            this.setState({
                checkedMaplegend: "No Status",
                currentPin: "default",
                currentSelectedPole: null,
                loading: true
            }, () => {
                //let boundInput = this.getBounds();
            })
        }
        else {
            this.setState({
                checkedMaplegend: type,
                currentSelectedPole: null,
                currentPin: pinType,
                loading: true
            }, () => {
                //let boundInput = this.getBounds();
            })
        }

    }

    handleMarkerOnClick(marker, e) {
        if (this.state.isStreetView || marker == null) {
            return
        }

        this.setState({
            currentSelectedPole: null,
            currentCenter: null
        }, () => {
            this.setState({
                currentSelectedPole: marker,
                currentCenter:marker?.coords
            });
        })
    }

    handleStreetViewMarkerOnClick(streetViewMarker, e) {
        if(streetViewMarker != null){
            this.setState({
                currentStreetViewSelectedPole: null,
                currentCenter: null
            }, () => {
                this.setState({
                    currentStreetViewSelectedPole: streetViewMarker,
                    showStreetviewPoleMenu: true,
                    currentCenter:streetViewMarker?.coords,
                });
            })
        }
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            var searchInput = e.target.value;
            var lookupData = this.state.mapData;
            var test = lookupData.filter(function (data) {
                return lookupData !== null ? data.info.StructureID === searchInput : null
            });
            if (test) {
                this.setState({
                    currentSelectedPole: null,
                    zoomLevel: null,
                    currentCenter: null
                }, () => {
                    this.setState({
                        currentSelectedPole: test.length === 0 ? null : test[0],
                        zoomLevel: 16,
                        currentCenter: test.length === 0 ? null : test[0]?.coords,
                        isrecenter: !this.state.isrecenter
                    });
                })
            }
        }
    }

    handleWarningIconClick = () => {
        this.setState({
            showErrorMessage: !this.state.showErrorMessage,
        });

    }
    handleMapOnClick(event) {
        if (this.state.isStreetView && this.panoramaInstance) {
            this.panoramaInstance.setPosition(event.latLng);
        }
        this.setState({
            currentSelectedPole: null,
        })
    }

    handleDraw() {
        this.setState({
            drawOption: "rectangle",
        })
    }

    handleOffDraw() {
        this.state.drawingRec.setMap(null);
        this.setState({
            drawOption: "maker",
            lassoWindow: false
        })
    }

    onLoad(autocomplete) {
        this.autocomplete = autocomplete
    }

    showDrawer = () => {
        this.setState({
            showDrawer: !this.state.showDrawer
        })
    }

    getBounds = () => {
        if (!this.state.map || !this.state.map.getBounds) {
            return null;
        }

        let bounds = this.state.map.getBounds();
        if (!bounds) {
            return null; 
        }

        let center = this.state.map.getCenter();

        let lat = center.lat();
        let long = center.lng();

        let ne = bounds.getNorthEast(); // LatLng of the north-east corner
        let sw = bounds.getSouthWest(); // LatLng of the south-west corner

        let bbox = {
            north: ne.lat(),
            east: ne.lng(),
            south: sw.lat(),
            west: sw.lng(),
            lat: lat,
            long: long
        };

        return bbox;
    };

    boundsCallBack = () => {
        setTimeout(() => {
            let boundInput = this.getBounds();
            if (!boundInput) return;
            this.updateFilteredMapData({bounds: boundInput});
            // this.populateMapData(boundInput, this.state.checkedMaplegend);
        }, 500)
    }

    boundsZoomCallBack = () => {
        setTimeout(() => {
            let boundInput = this.getBounds();
            if (!boundInput) return;
            this.updateFilteredMapData({bounds: boundInput});
            // this.populateMapData(boundInput, this.state.checkedMaplegend);
        }, 1000)
    }

    findFirstHighlighted = () => {
        const { highlightedPoles } = this.props.highlightedPolesContext;
        const pole = this.state.mapData.find((item) => highlightedPoles.includes(item.info?.GlobalID));
        if (pole) {
            this.setState({
                currentCenter: pole.coords,
                zoomLevel: 16
            }, () => {
                this.updateFilteredMapData({
                    bounds: this.getBounds(),
                    skipHighlighted: true,
                });
                return this.getBounds();
            });
        }
    };
    clearClustererMarkers = () => {
        if (this.state.filteredMapData) {
            this.state.filteredMapData.forEach((marker) => {
                window.google.maps.event.clearInstanceListeners(marker);
            });
        }
        
        if (this.inspectedPIClusterer) this.inspectedPIClusterer.clearMarkers();
        if (this.notInspectedPIClusterer) this.notInspectedPIClusterer.clearMarkers();
        if (this.restorableRejectsPIClusterer) this.restorableRejectsPIClusterer.clearMarkers();
        if (this.nonRestorableRejectsPIClusterer) this.nonRestorableRejectsPIClusterer.clearMarkers();
        if (this.auditedPRClusterer) this.auditedPRClusterer.clearMarkers();
        if (this.notAuditedPRClusterer) this.notAuditedPRClusterer.clearMarkers();
        if (this.rejectedUGClusterer) this.rejectedUGClusterer.clearMarkers();
        if (this.inspectedUGClusterer) this.inspectedUGClusterer.clearMarkers();
        if (this.notInspectedUGClusterer) this.notInspectedUGClusterer.clearMarkers();
        if (this.othersClusterer) this.othersClusterer.clearMarkers();
    }
    clearStreetViewMarkers = () => {
        this.streetViewMarkers.forEach(m => {
            window.google.maps.event.clearInstanceListeners(m);
            m.setMap(null);
        });
        this.streetViewMarkers = [];
    }
    updateFilteredMapData = (options = {}) => {
        const registerActiveMarker = (item, marker, allFilters, specificFilter) => {
            allFilters.push(marker);
            specificFilter.push(marker);
            this.createStreetViewMarker(item);
        };
        const { highlightedPoles } = this.props.highlightedPolesContext;
        const {mapData, showPIInspected, showPINotInspected, showPINonRestorableRejects,
            showPIRestorableRejects, showPRAudited, showPRNotAudited, showUGInspected,
            showUGNotInspected, showUGRejects, showOthers,
        } = this.state;
        let firstHighlightedBounds;
        if (highlightedPoles.length > 0 && !options?.skipHighlighted && this.firstTime) {
            firstHighlightedBounds = this.findFirstHighlighted();
            this.firstTime = false;
            return;
        }
        if (!firstHighlightedBounds) {
            firstHighlightedBounds = options?.bounds;
        }
        const filteredMapData = {
            allFilters: [],
            inspected: [],
            notInspected: [],
            restorable: [],
            nonRestorable: [],
            audited: [],
            notAudited: [],
            rejectedUG: [],
            inspectedUG: [],
            notInspectedUG: [],
            others: [],
        };
        const bounds = firstHighlightedBounds ?? this.state.box;
        if (!bounds || bounds.north === undefined) {
            return;
        }
        this.clearClustererMarkers();
        this.clearStreetViewMarkers();

        mapData.forEach((item) => {
            const isWithinBounds = item.coords.lat <= bounds.north && item.coords.lat >= bounds.south && item.coords.lng >= bounds.west && item.coords.lng <= bounds.east;
            if (!isWithinBounds) {  
                return;
            }
            
            const isNotHighlighted = highlightedPoles.length > 0 && !highlightedPoles.includes(item.info?.GlobalID);
            if (isNotHighlighted) {
                return;
            }
            
            const marker = new window.google.maps.Marker({
                position: item.coords,
                icon: item.iconSymbol,
                label: item.info?.Type === "Underground" && item.info?.StructureType 
                ? {
                    text: getStructureLabel(item.info?.StructureType), 
                    color: "#FFFFFF",
                    fontWeight: "bold" 
                } 
                : null 
            });
            marker.addListener("click", (event) => {
                this.handleMarkerOnClick(item, event);
            });
            const type = item.info?.Type;
            switch(type) {
                case 'Inspection Pole': {
                    const key = (item.info?.SymbologyKey || "").toLowerCase();
                    switch(key) {
                        case 'not_inspected': {
                            if (showPINotInspected) {
                                registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.notInspected);
                            }
                            break;
                        }
                        case 'inspected': {
                            if (showPIInspected)  {
                                registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.inspected);
                            }
                            break;
                        }
                        case 'non_restorable_rejects': {
                            if (showPINonRestorableRejects)  {
                                registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.nonRestorable);
                            }
                            break;
                        }
                        case 'restorable_rejects': {
                            if (showPIRestorableRejects)  {
                                registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.restorable);
                            }
                            break;
                        }
                        default: {
                            if (showOthers)  {
                                registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.others);
                            }
                        }
                    }
                    break;
                }
                case 'Restoration Pole': {
                    const isAudited = !!item.info?.Audit_Date;
                    if (isAudited) {
                        if (showPRAudited) {
                            registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.audited);
                        }
                    } else {
                        if (showPRNotAudited) {
                            registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.notAudited);
                        }
                    }
                    break;
                }
                case 'Underground': {
                    const rejectStatus = (item.info?.Rejects ?? "").toString().trim();
                    const auditStatus = (item.info?.Audit_Date ?? "").toString().trim();

                    const isReject = rejectStatus === "Yes";
                    if (isReject) {
                        if (showUGRejects)  {
                            registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.rejectedUG);
                        }
                    } else {
                        switch (auditStatus) {
                            case 'Audited': {
                                if (showUGInspected) {
                                    registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.inspectedUG);
                                }
                                break;
                            }
                            case 'Not Audited': {
                                if (showUGNotInspected) {
                                    registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.notInspectedUG);
                                }
                                break;
                            }
                            default: {
                                if (showOthers) {
                                    registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.others);
                                }
                            }
                        }
                    }                      
                    break;
                }
                default: {
                    if (showOthers)  {
                        registerActiveMarker(item, marker, filteredMapData.allFilters, filteredMapData.others);
                    }
                }
            }
        });

        if (this.notInspectedPIClusterer) this.notInspectedPIClusterer.addMarkers(filteredMapData.notInspected);
        if (this.inspectedPIClusterer) this.inspectedPIClusterer.addMarkers(filteredMapData.inspected);
        if (this.nonRestorableRejectsPIClusterer) this.nonRestorableRejectsPIClusterer.addMarkers(filteredMapData.nonRestorable);
        if (this.restorableRejectsPIClusterer) this.restorableRejectsPIClusterer.addMarkers(filteredMapData.restorable);
        if (this.auditedPRClusterer) this.auditedPRClusterer.addMarkers(filteredMapData.audited);
        if (this.notAuditedPRClusterer) this.notAuditedPRClusterer.addMarkers(filteredMapData.notAudited);
        if (this.rejectedUGClusterer) this.rejectedUGClusterer.addMarkers(filteredMapData.rejectedUG);
        if (this.inspectedUGClusterer) this.inspectedUGClusterer.addMarkers(filteredMapData.inspectedUG);
        if (this.notInspectedUGClusterer) this.notInspectedUGClusterer.addMarkers(filteredMapData.notInspectedUG);
        if (this.othersClusterer) this.othersClusterer.addMarkers(filteredMapData.others);

        this.setState({ 
            filteredMapData: filteredMapData.allFilters,
            box: bounds,
         }, () => {
            if (this.legendLoading) {
                this.setState({ legendLoading: false });
            }
        });
    };

    createStreetViewMarker = async (item) => {
        const hasMarkerLabel = item.info?.Type === "Underground" && item.info?.StructureType;
        const newIconSymbol = hasMarkerLabel ? await generateIconWithLabel(item.iconSymbol, getStructureLabel(item.info?.StructureType), "white") : item.iconSymbol;

        const streetViewMarker = new window.google.maps.Marker({
            position: item.coords,
            icon: newIconSymbol,
            altitude: 20,
            map: this.panoramaInstance,
        });

        this.streetViewMarkers.push(streetViewMarker);

        streetViewMarker.addListener("click", (event) => {
            this.handleStreetViewMarkerOnClick(item, event);
        });

        streetViewMarker.addListener("mouseover", () => {
            if (this.state.isStreetView) {
                document.documentElement.style.setProperty("--streetview-marker-hover-label-icon", `url('${newIconSymbol}')`);

                let poleType = item.info?.Type;
                let poleStatusLabel = "Other";

                if (poleType === 'Inspection Pole') {
                    poleStatusLabel = (item.info?.SymbologyKey || "")
                        .replace(/_/g, ' ') //Replace underscore with space
                        .replace(/\b\w/g, char => char.toUpperCase()) // make first letter upper case
                } else if (poleType === 'Restoration Pole') {
                    poleStatusLabel = item.info?.Audit_Date ? 'Audited' : 'Not Audited';
                } else if (poleType === 'Underground') {
                    const isReject = (item.info?.Rejects ?? "").toString().trim() === "Yes";
                    const auditStatus = (item.info?.Audit_Date ?? "").toString().trim();

                    if (isReject) {
                        poleStatusLabel = 'Rejected';
                    } else if (auditStatus === 'Audited' || auditStatus === 'Not Audited') {
                        poleStatusLabel = auditStatus; 
                    }
                }

                streetViewMarker.setLabel({
                    text: poleStatusLabel,
                    className: "streetview-marker-hover-label" 
                });
            }
        });
        
        streetViewMarker.addListener("mouseout", () => {
            if (this.state.isStreetView) {
                streetViewMarker.setLabel(null);
            }
        });
        return streetViewMarker;
    }

    getMarkerClusterer = (map, clusterName) => {
        return new MarkerClusterer({
            map, markers: [], renderer: clusterStyles[clusterName], 
            algorithm: new SuperClusterAlgorithm({
                radius: 120,
                minPoints: 5,
            }), 
        })
    }

    debounceGetStreetViewAddress = debounce((position) => {
        reverseGeocodeAddress(this.geocoder, position)  
            .then((addressData) => {
                this.setState({
                    currentAddress: addressData.address,
                    currentCity: addressData.city
                });
            })
            .catch((error) => console.warn(error));
    }, 500);

    handleStreetViewPositionChange = () => {
        if (!this.panoramaInstance) return;
        
        const pos = this.panoramaInstance.getPosition();
        
        if (!pos) return;
        
        this.setState({
            currentCenter: { lat: pos.lat(), lng: pos.lng() },
        });
        if (!this.state.showStreetviewPoleMenu) {
            this.debounceGetStreetViewAddress(pos);
        }
    }

    handleStreetViewVisibleChange = () => {
        if (!this.panoramaInstance) return;

        const isVisible = this.panoramaInstance.getVisible();
        
        if (isVisible) {
            this.coverageLayer.setMap(this.state.map);
            this.state.map.setOptions({ draggableCursor: 'pointer' });
            if (document.fullscreenElement) {
                document.exitFullscreen()
                    .catch((err) => console.error("Could not exit fullscreen:", err));
            }
        } else {
            this.coverageLayer.setMap(null);
            this.setState({ currentStreetViewSelectedPole: null, showStreetviewPoleMenu: false });
            this.state.map.setOptions({ draggableCursor: null });
        }
        this.setState({ isStreetView: isVisible }, () => {
            setTimeout(() => {
                if (this.state.map) {
                    window.google.maps.event.trigger(this.state.map, 'resize');

                    this.state.map.setCenter(this.state.currentCenter);
                }

                if (isVisible && this.panoramaInstance) {
                    window.google.maps.event.trigger(this.panoramaInstance, 'resize');
                }
            }, 300);
        });
    }
    
    handleMapLoad = (map) => {
        this.setState({ map });

        this.coverageLayer = new window.google.maps.StreetViewCoverageLayer();
        this.geocoder = new window.google.maps.Geocoder();
        this.panoramaInstance = new window.google.maps.StreetViewPanorama(
            this.streetViewRef.current,
            {
                enableCloseButton: false,
                visible: false,
                disableDefaultUI: true,
            }
        );

        map.setStreetView(this.panoramaInstance);

        this.panoramaInstance.addListener('position_changed', () => {
            this.handleStreetViewPositionChange();
        });

        this.panoramaInstance.addListener('visible_changed', () => {
            this.handleStreetViewVisibleChange();
        });

        this.notInspectedPIClusterer = this.getMarkerClusterer(map, 'not-inspected');
        this.inspectedPIClusterer = this.getMarkerClusterer(map, 'inspected');
        this.nonRestorableRejectsPIClusterer = this.getMarkerClusterer(map, 'non-restorable-rejects');
        this.restorableRejectsPIClusterer = this.getMarkerClusterer(map, 'restorable-rejects');
        this.auditedPRClusterer = this.getMarkerClusterer(map, 'audited');
        this.notAuditedPRClusterer = this.getMarkerClusterer(map, 'non-audited');
        this.inspectedUGClusterer = this.getMarkerClusterer(map, 'inspected-ug');
        this.notInspectedUGClusterer = this.getMarkerClusterer(map, 'not-inspected-ug');
        this.rejectedUGClusterer = this.getMarkerClusterer(map, 'rejected-ug');
        this.othersClusterer = this.getMarkerClusterer(map, 'others');

        setTimeout(() => {
            let boundInput = this.getBounds();
            this.setState({ box: boundInput });
            
            this.updateFilteredMapData(); 
        }, 500)
    }

    handleStreetViewZoomChange = (panoramaInstance, zoomChangeValue) => {
        if (!panoramaInstance) return;

        const currentZoomLevel = panoramaInstance.getZoom() || 0;
        this.panoramaInstance.setZoom(currentZoomLevel + zoomChangeValue);
    }

    handleChange = (e) => {
        if (e.value.end != null) {
            this.setState({
                dateStart: moment(e.value.start).format('yyyy-MM-DD hh:mm:ss'),
                dateEnd: moment(e.value.end).format('yyyy-MM-DD hh:mm:ss'),
                showDate: e.value,
            }, () => { this.handleFilterUpdate() })
        }
    }

    handleCleanDate = () => {
        this.setState({
            dateStart: null,
            dateEnd: null,
            showDate: {}
        }, () => { this.handleFilterUpdate() })
    }

    handleClearMapFilter = () => {
        const { setHighlightedPoles } = this.props.highlightedPolesContext;
        setHighlightedPoles([]);
        this.setState(
            {
                showPIInspected: true,
                showPINotInspected: true,
                showPINonRestorableRejects: true,
                showPIRestorableRejects: true,
                showPRAudited: true,
                showPRNotAudited: true,
                showUGInspected: true,
                showUGNotInspected: true,
                showUGRejects: true,
                showOthers: true,
                currentSelectedPole: null,
            }, this.updateFilteredMapData
        );
    };

    handleGoToReport = () => {
        const { setSelectedTab } = this.props.tabContext;
        setSelectedTab(1);
        this.props.navigate('/report');

        this.setState({ currentSelectedPole: null });
    }

    handleFilterUpdate = () => {
        this.setState({
            loading: true
        })
        let tempQuery = "";
        let tempQuery1 = "";
        let tempQuery2 = "";
        let tempQuery3 = "";
        const temparray = [];
        if (this.state.created_user.length > 0) {
            const tempString = this.state.created_user.map((value) => `${"'" + value + "'"}`).join(',');
            tempQuery = "created_user In (" + tempString + ")";
        }
        else {
            tempQuery = "";
        }

        if (this.state.Reject_Status.length > 0) {
            const tempString = this.state.Reject_Status.map((value) => `${value}`).join(',');
           tempQuery1 = "Reject_Status In (" + tempString + ")";
        }
        else {
            tempQuery1 = "";
        }

        if (this.state.dateEnd != null && this.state.dateStart != null) {
            const tempString = "created_date < '" + this.state.dateEnd + "' and created_date > '" + this.state.dateStart + "'";
            tempQuery2 = tempString;
        }
        else {
            tempQuery2 = "";
        }
        if (this.state.audit_childbox_audited) {
            tempQuery3 = 'audit_user is not null'
        }

        if (tempQuery !== "") {
            temparray.push(tempQuery);
        }
        if (tempQuery1 !== "") {
            temparray.push(tempQuery1);
        }
        if (tempQuery2 !== "") {
            temparray.push(tempQuery2);
        }
        if (tempQuery3 !== "") {
            temparray.push(tempQuery3);
        }
        var rawQuery = temparray.map((value) => `${value}`).join(' and ');
        this.populateMapData(rawQuery);
    }

    handleCondition = (condition) => {
        if (condition === "1") {
            return "Non Reject";
        }
        else if (condition === "2") {
            return "Non Restorable Reject";
        }
        else if (condition === "3") {
            return "Priority Non Restorable Reject";
        }
        else if (condition === "4") {
            return "Priority Restorable Reject";
        }
        else if (condition === "5") {
            return "Restorable Reject";
        }
    }

    assignPoleSymbologyColor = (pole) => {

        const type = pole?.info?.Type;

        if (type === "Inspection Pole") {
            const key = (pole?.info?.SymbologyKey || "").toLowerCase();

            switch (key) {
                case "not_inspected":
                    return PIBlack;
                case "inspected":
                    return PIGreen;
                case "non_restorable_rejects":
                    return PIRed;
                case "restorable_rejects":
                    return PIYellow;
                default:
                    return othersIcon;
            }
        }

        if (type === "Restoration Pole") {
            return pole?.info?.Audit_Date ? PRAudited : PRNotAudited;
        }

        if (type === "Underground") {
            const rejectStatus = (pole?.info?.Rejects ?? "").toString().trim();

            if (rejectStatus === "Yes") return UGRejected;
            if (pole?.info?.Audit_Date === "Audited" && rejectStatus !== "Yes") return UGInspected;
            if (pole?.info?.Audit_Date === "Not Audited") return UGNotInspected;
            return othersIcon;
        }

        return othersIcon;
    };
    
    render() {
        const { highlightedPoles } = this.props.highlightedPolesContext;
       
        const legendWithoutFilterApplied = (
            <div className="pulse-map-legend-rs-ug">
                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[
                            { height: 25 },
                            { height: 25 },
                            { height: 25 },
                            { height: 25 },
                            { height: 25 },
                        ]}
                        cols={[
                            { width: 20 },
                            { width: 20 },
                            { width: 20 },
                            { width: 80 },
                        ]}
                        gap={{ rows: 3, cols: 4 }}
                    >
                        {/* Group toggle */}
                        <GridLayoutItem row={1} col={1}>
                            <Checkbox
                                checked={
                                    this.state.showPINotInspected ||
                                    this.state.showPIInspected ||
                                    this.state.showPINonRestorableRejects ||
                                    this.state.showPIRestorableRejects
                                }
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        {
                                            showPINotInspected: isChecked,
                                            showPIInspected: isChecked,
                                            showPINonRestorableRejects: isChecked,
                                            showPIRestorableRejects: isChecked,
                                            currentSelectedPole: null
                                        },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>

                        <GridLayoutItem row={1} col={2} colSpan={3}>
                            <div className="legend-row-rs">Inspection</div>
                        </GridLayoutItem>

                        {/* Row 2: Not Inspected */}
                        <GridLayoutItem row={2} col={2}>
                            <Checkbox
                                value={this.state.showPINotInspected}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showPINotInspected ? "#000" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPINotInspected: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={3}>
                            <img className="pulse-map-legend-icon" src={PIBlack} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={4}>Not Inspected</GridLayoutItem>

                        {/* Row 3: Inspected */}
                        <GridLayoutItem row={3} col={2}>
                            <Checkbox
                                value={this.state.showPIInspected}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showPIInspected ? "#20790A" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPIInspected: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={3}>
                            <img className="pulse-map-legend-icon" src={PIGreen} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={4}>Inspected</GridLayoutItem>

                        {/* Row 4: Non Restorable Rejects */}
                        <GridLayoutItem row={4} col={2}>
                            <Checkbox
                                checked={this.state.showPINonRestorableRejects}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showPINonRestorableRejects ? "#FF0000" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPINonRestorableRejects: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={4} col={3}>
                            <img className="pulse-map-legend-icon" src={PIRed} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={4} col={4}>Non Restorable Rejects</GridLayoutItem>

                        {/* Row 5: Restorable Rejects */}
                        <GridLayoutItem row={5} col={2}>
                            <Checkbox
                                value={this.state.showPIRestorableRejects}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showPIRestorableRejects ? "#FFC517" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPIRestorableRejects: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={5} col={3}>
                            <img className="pulse-map-legend-icon" src={PIYellow} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={5} col={4}>Restorable Rejects</GridLayoutItem>
                    </GridLayout>
                </div>

                <div className="pulse-map-legend-rs-container">

                    <GridLayout
                        rows={[{
                            height: 25
                        }, {
                                height: 25
                        }, {
                                height: 25
                            }]}
                        cols={[{
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 80
                        }]}
                        gap={{
                            rows: 3,
                            cols: 4,
                        }}
                    >
                        <GridLayoutItem row={1} col={1} className="" >
                            <Checkbox
                                checked={(this.state.showPRAudited || this.state.showPRNotAudited) ? true : false}
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPRAudited: isChecked, showPRNotAudited: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={1} col={2} colSpan={3} className="" >
                            <div className="legend-row-rs">
                                Restoration
                            </div>
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={2} className="" >
                            <Checkbox
                                checked={this.state.showPRAudited}
                                style={{ borderColor: "#051A38", backgroundColor: this.state.showPRAudited ? "#20790A" : "#FFFFFF", borderWidth: "1px", width: "20px", height: "20px" }}
                                className="legend-checkbox"
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPRAudited: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={3}>
                            <img className="pulse-map-legend-icon-PR" src={PRAudited} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={4}>
                            <div className="">
                                Audited
                            </div>
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={2} className="" >
                            <Checkbox
                                checked={this.state.showPRNotAudited}
                                className="legend-checkbox"
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "20px", backgroundColor: this.state.showPRNotAudited ? "#000" : "#FFFFFF", height: "20px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showPRNotAudited: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={3} className="" >
                            <img className="pulse-map-legend-icon-PR" src={PRNotAudited} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={3} col={4}>
                            <div className="" >
                                Not Audited
                            </div>
                        </GridLayoutItem>
                    </GridLayout>
                </div>

                <div className="pulse-map-legend-rs-container">

                    <GridLayout
                        rows={[{
                            height: 25
                        }, {
                            height: 25
                        }, {
                            height: 25
                            }, {
                                height: 25
                            }]}
                        cols={[{
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 120
                            }]}
                        gap={{
                            rows: 4,
                            cols: 4,
                        }}
                    >
                        <GridLayoutItem row={1} col={1} className="" >
                            <Checkbox
                                checked={(this.state.showUGInspected || this.state.showUGNotInspected|| this.state.showUGRejects) ? true : false}
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "20px", height: "20px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showUGInspected: isChecked, showUGNotInspected: isChecked, showUGRejects: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={1} col={2} colSpan={3} className="" >
                            <div className="legend-row-rs">
                                Underground
                            </div>
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={2} className="" >
                            <Checkbox
                                checked={this.state.showUGInspected}
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "20px", backgroundColor: this.state.showUGInspected ? "#20790A" : "#FFFFFF", height: "20px" }}
                                className="legend-checkbox"
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;   
                                    this.setState(
                                        { showUGInspected: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={3}>
                            <img className="pulse-map-legend-icon-PR" src={UGInspected} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={4}>
                            <div className="">
                                Inspected
                            </div>
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={2} className="" >
                            <Checkbox
                                checked={this.state.showUGNotInspected}
                                className="legend-checkbox"
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "20px", backgroundColor: this.state.showUGNotInspected ? "#000" : "#FFFFFF", height: "20px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showUGNotInspected: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={3} className="" >
                            <img className="pulse-map-legend-icon-PR" src={UGNotInspected} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={3} col={4}>
                            <div className="" >
                                Not Inspected
                            </div>
                        </GridLayoutItem>
                        <GridLayoutItem row={4} col={2} className="" >
                            <Checkbox
                                checked={this.state.showUGRejects}
                                className="legend-checkbox"
                                style={{ borderColor: "#051A38", borderWidth: "1px", width: "20px", backgroundColor: this.state.showUGRejects ? "#FF0000" : "#FFFFFF", height: "20px" }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showUGRejects: isChecked, currentSelectedPole: null, },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>
                        <GridLayoutItem row={4} col={3} className="" >
                            <img className="pulse-map-legend-icon-PR" src={UGRejected} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={4} col={4}>
                            <div className="" >
                                Reject
                            </div>
                        </GridLayoutItem>
                    </GridLayout>
                    <div style={{ padding: "4px 2px 4px 24px", whiteSpace: "normal", lineHeight: "1.3", wordWrap: "break-word", width: "100%", boxSizing: "border-box" }}>
                         <strong>Labels:</strong> L-Light, V-Vault, P-Pedestal, J-JBox, G-Switch Gear, H-Hand Hole, 3T-Three-Phase, 1T-Single-Phase
                    </div>
                </div>

                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[{ height: 25 }, { height: 25 }]}
                        cols={[{ width: 20 }, { width: 20 }, { width: 20 }, { width: 80 }]}
                        gap={{ rows: 3, cols: 4 }}
                    >
                        <GridLayoutItem row={1} col={2} colSpan={3}>
                            <div className="legend-row-rs">Others</div>
                        </GridLayoutItem>

                        <GridLayoutItem row={2} col={2}>
                            <Checkbox
                                checked={this.state.showOthers}
                                className="legend-checkbox"
                                style={{
                                    backgroundColor: this.state.showOthers ? "#000" : "#FFFFFF",
                                    borderColor: "#051A38",
                                    borderWidth: "1px",
                                    width: "20px",
                                    height: "20px",
                                }}
                                onChange={(e) => {
                                    const isChecked = e.syntheticEvent.target.checked;
                                    this.setState(
                                        { showOthers: isChecked, currentSelectedPole: null },
                                        this.updateFilteredMapData
                                    );
                                }}
                            />
                        </GridLayoutItem>

                        <GridLayoutItem row={2} col={3}>
                            <img className="pulse-map-legend-icon" src={othersIcon} alt="Others" />
                        </GridLayoutItem>

                        <GridLayoutItem row={2} col={4}>Others</GridLayoutItem>
                    </GridLayout>
                </div>

                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[
                            { height: 25 },
                        ]}
                        cols={[
                            { width: 20 },
                            { width: 20 },
                            { width: 20 },
                            { width: 80 },
                        ]}
                        gap={{ rows: 3, cols: 4 }}
                    >
                        <GridLayoutItem row={1} col={2} colSpan={3}>
                            <div className="legend-row-rs">Displayed pole count: {this.state.filteredMapData.length}</div>
                        </GridLayoutItem>
                    </GridLayout>
                </div>
            </div>
        );

        const legendWithFilterApplied = (
            <div className="pulse-map-legend-rs-ug">
                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[
                            { height: 25 },
                            { height: 25 },
                            { height: 25 },
                            { height: 25 },
                            { height: 25 },
                        ]}
                        cols={[
                            { width: 20 },
                            { width: 20 },
                            { width: 80 },
                        ]}
                        gap={{ rows: 3, cols: 3 }}
                    >
                        <GridLayoutItem row={1} col={1} colSpan={3}>
                            <div className="legend-row-rs">Inspection</div>
                        </GridLayoutItem>

                        {/* Row 2: Not Inspected */}
                        <GridLayoutItem row={2} col={2}>
                            <img className="pulse-map-legend-icon" src={PIBlack} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={3}>Not Inspected</GridLayoutItem>

                        {/* Row 3: Inspected */}
                        <GridLayoutItem row={3} col={2}>
                            <img className="pulse-map-legend-icon" src={PIGreen} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={3} col={3}>Inspected</GridLayoutItem>

                        {/* Row 4: Non Restorable Rejects*/}
                        <GridLayoutItem row={4} col={2}>
                            <img className="pulse-map-legend-icon" src={PIRed} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={4} col={3}>Non Restorable Rejects</GridLayoutItem>

                        {/* Row 5: Restorable Rejects */}
                        <GridLayoutItem row={5} col={2}>
                            <img className="pulse-map-legend-icon" src={PIYellow} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem row={5} col={3}>Restorable Rejects</GridLayoutItem>
                    </GridLayout>
                </div>

                <div className="pulse-map-legend-rs-container">

                    <GridLayout
                        rows={[{
                            height: 25
                        }, {
                            height: 25
                        }, {
                            height: 25
                        }]} cols={[{
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 80
                        }]}
                        gap={{
                            rows: 3,
                            cols: 3,
                        }}
                    >
                        <GridLayoutItem row={1} col={1} colSpan={3} className="" >
                            <div className="legend-row-rs">
                                Restoration
                        </div>
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={2}>
                            <img className="pulse-map-legend-icon-PR" src={PRAudited} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={3}>
                            <div className="">
                                Audited
                            </div>
                        </GridLayoutItem>

                        <GridLayoutItem row={3} col={2} className="" >
                            <img className="pulse-map-legend-icon-PR" src={PRNotAudited} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={3} col={3}>
                            <div className="" >
                                Not Audited
                            </div>
                        </GridLayoutItem>
                    </GridLayout>
                </div>

                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[{
                            height: 25
                        }, {
                            height: 25
                        }, {
                            height: 25
                        }]} cols={[{
                            width: 20
                        }, {
                            width: 20
                        }, {
                            width: 100
                        }]}
                        gap={{
                            rows: 4,
                            cols: 3,
                        }}
                    >
                        <GridLayoutItem row={1} col={1} colSpan={3} className="" >
                            <div className="legend-row-rs">
                                Underground
                        </div>
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={2}>
                            <img className="pulse-map-legend-icon-PR" src={UGInspected} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={2} col={3}>
                            <div className="">
                                Inspected
                            </div>
                        </GridLayoutItem>

                        <GridLayoutItem row={3} col={2} className="" >
                            <img className="pulse-map-legend-icon-PR" src={UGNotInspected} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={3} col={3}>
                            <div className="" >
                                Not Inspected
                            </div>
                        </GridLayoutItem>

                        <GridLayoutItem row={4} col={2} className="" >
                            <img className="pulse-map-legend-icon-PR" src={UGRejected} alt="Pole" />
                        </GridLayoutItem>
                        <GridLayoutItem className="" row={4} col={3}>
                            <div className="" >
                                Reject
                            </div>
                        </GridLayoutItem>
                    </GridLayout>
                    <div style={{ padding: "4px 2px 4px 24px", whiteSpace: "normal", lineHeight: "1.3", wordWrap: "break-word", width: "100%", boxSizing: "border-box" }}>
                        <strong>Labels:</strong> L-Light, V-Vault, P-Pedestal, J-JBox, G-Switch Gear, H-Hand Hole, 3T-Three-Phase, 1T-Single-Phase
                    </div>
                </div>

                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[{ height: 25 }, { height: 25 }]}
                        cols={[{ width: 20 }, { width: 20 }, { width: 80 }]}
                        gap={{ rows: 3, cols: 3 }}
                    >
                        <GridLayoutItem row={1} col={1} colSpan={3}>
                            <div className="legend-row-rs">Others</div>
                        </GridLayoutItem>

                        <GridLayoutItem row={2} col={2}>
                            <img className="pulse-map-legend-icon" src={othersIcon} alt="Others" />
                        </GridLayoutItem>
                        <GridLayoutItem row={2} col={3}>Others</GridLayoutItem>
                    </GridLayout>
                </div>

                <div className="pulse-map-legend-rs-container">
                    <GridLayout
                        rows={[
                            { height: 25 },
                        ]}
                        cols={[
                            { width: 20 },
                            { width: 20 },
                            { width: 20 },
                            { width: 80 },
                        ]}
                        gap={{ rows: 3, cols: 4 }}
                    >
                        <GridLayoutItem row={1} col={2} colSpan={3}>
                            <div className="legend-row-rs">Displayed pole count: {this.state.filteredMapData.length}</div>
                        </GridLayoutItem>
                    </GridLayout>
                </div>
            </div>
        );

        const NoDataComponent = () => (
            <div>
                <img className='pulse-no-access-image' src={noaccess} alt="No Access" />
                <h3 className='pulse-no-access-image-text'>This project does not have any data yet.</h3>
            </div>
        );

        return (
            <>
                <p className="pulse-chart-title" style={{ marginLeft: "0px" }}>{ this.state.isStreetView ? "Street View:" : "Map View:"}</p>
                {this.state.nodata ? (
                    <NoDataComponent />
                ) : this.state.loading ? (
                    <div className='nimbly2-map-loader-rs'>
                        <img className='nimbly2-map-loader-gif-rs' src={loadinggif} alt="Loading..." />
                        <img className='nimbly2-map-loader-text-rs' src={loadingtext} alt="Loading Text" />
                    </div>
                    ) : (
                            <div className='nimbly-map-wrapper'>
                                <div className={`${this.state.loading ? "nimbly-map-loading" : "map-container"} ${this.state.isStreetView ? 'is-mini-map' : ''} ${this.state.showStreetviewPoleMenu ? 'extra-space' : ''}`} >
                                    <GoogleMap
                                        mapContainerStyle={this.props.fullSizeMap ? containerStyleFullSize : containerStyle}
                                        center={this.state.currentCenter}
                                        zoom={this.state.zoomLevel}
                                        // options={getMapOptions()}
                                        onClick={this.handleMapOnClick}
                                        onFail={error => console.log(error)}
                                        onDragEnd={this.boundsCallBack}
                                        onLoad={this.handleMapLoad}
                                        onZoomChanged={this.boundsZoomCallBack}
                                        options={{
                                            cameraControl: !this.state.isStreetView,
                                            cameraControlOptions: {
                                                position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
                                            },
                                            mapTypeControl: !this.state.isStreetView,
                                            mapTypeControlOptions: {
                                                position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
                                            },
                                            fullscreenControl: !this.state.isStreetView,
                                            fullscreenControlOptions: {
                                                position: window.google.maps.ControlPosition.RIGHT_BOTTOM,
                                            },
                                            streetViewControl: !this.state.isStreetView,
                                            streetViewControlOptions: {
                                                position: window.google.maps.ControlPosition.TOP_RIGHT, // Adjusted manually using css because it wasn't aligning properly with the other controls
                                            },
                                        }}
                                    >
                                        { !this.state.isStreetView && 
                                            <>
                                                <div className="map-button-group">
                                                    <Button onClick={() => this.handleClearMapFilter()} className="map-button" >
                                                        Reset Map Filter
                                                    </Button>
                                                    {highlightedPoles && highlightedPoles.length > 0 && (
                                                        <Button onClick={() => this.handleGoToReport()} className="map-button">
                                                            Go to Report
                                                        </Button>
                                                    )}
                                                </div>
                                                <GridLayout gap={{
                                                    cols: 0,
                                                    row: 6
                                                }}
                                                    className={highlightedPoles && highlightedPoles.length > 0 ? "pulse-map-searchbox-container-querymap" : "pulse-map-searchbox-container"}
                                                >
                                                    <GridLayoutItem className="box rect" col={1} row={1}>
                                                        <DropDownList
                                                            id="genre"
                                                            className="pulse-map-searchbox-dropdown"
                                                            data={mapSearchOption}
                                                            value={this.state.searchType}
                                                            onChange={(e) => this.handleSearchTypeChange(e)}
                                                        />
                                                    </GridLayoutItem>
                                                    <GridLayoutItem className="box" col={2} row={1}>
                                                        {this.state.searchType === "Structure ID" ?
                                                            <input
                                                                onKeyUp={(e) => this.handleKeyPress(e)}
                                                                type="text"
                                                                placeholder="Search Maps"
                                                                className="pulse-map-searchbox-input"

                                                            /> :
                                                            <Autocomplete
                                                                onLoad={this.onLoad}
                                                                onPlaceChanged={this.onPlaceChanged}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search Maps"
                                                                    className={this.state.addressValid ? "pulse-map-searchbox-input" : "pulse-map-searchbox-input pulse-map-searchbox-input-error"}
                                                                    //valid={this.state.addressValid}
                                                                    onKeyUp={(e) => this.handleAddressKeyPress(e)}
                                                                />
                                                            </Autocomplete>
                                                        }
                                                    </GridLayoutItem>
                                                    <GridLayoutItem className="box rect parent" col={3} row={1} >
                                                        {this.state.addressValid ? null :
                                                            <span className="pulse-input-icon">
                                                                <img
                                                                    src={validationIcon}
                                                                    alt="Warning"
                                                                    className="pulse-address-search-warning-icon"
                                                                    onMouseDown={(e) => e.target.style.transform = 'scale(0.9)'} // Visual feedback
                                                                    onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                                                                    onClick={() => this.handleWarningIconClick()}
                                                                />
                                                            </span>
                                                        }
                                                    </GridLayoutItem>

                                                    <GridLayoutItem className="box rect" col={1} row={2} colSpan={2}>
                                                        {
                                                            this.state.showErrorMessage ?
                                                                <div className="white-box"  ref={this.wrapperRef} >
                                                                    <h2 className="box-header">Maps cannot find {this.state.searchEnteredAddress}.</h2>
                                                                    <p className="box-content">
                                                                        Make sure your search is spelled correctly.Try adding a city, state, or zip code.
                                                        </p>
                                                                </div> : null
                                                        }
                                                    </GridLayoutItem>
                                                </GridLayout>
                                            </>
                                        }
                                        
                                        {this.state.isSearchByAddress ?
                                            <MarkerF
                                                key={this.state.currentCenter}
                                                position={this.state.currentCenter}
                                                icon={addressIcon}
                                            >
                                            </MarkerF> : null
                                        }
                                        {this.state.filteredMapData == null || this.state.filteredMapData.length <= 0 ? 
                                            (
                                                "loading"
                                            )
                                                : 
                                            (
                                                <>
                                                    {this.state.currentSelectedPole !== null && (
                                                        <InfoWindow position={this.state.currentSelectedPole.coords} onCloseClick={() => this.setState({ currentSelectedPole: null })}>
                                                            <ExpandedUGPole item={this.state.currentSelectedPole} />
                                                        </InfoWindow>
                                                    )}
                                                </>
                                            )
                                        }
                                        <></>
                                    </GoogleMap>
                                    {
                                        !this.state.loading && !this.state.isStreetView && (
                                            highlightedPoles && highlightedPoles.length > 0
                                                ? legendWithFilterApplied
                                                : legendWithoutFilterApplied
                                        )}
                                </div>
                                <div ref={this.streetViewRef} className={`nimbly-streetview-layer ${this.state.isStreetView ? 'is-active' : ''}`}>
                                    {this.state.isStreetView && 
                                        <>
                                            <div className='streetview-inaccuracy-warning-label'>
                                                Images shown on Street View may not align directly to the actual Pole state. Please check “Photos”
                                            </div>
                                            <GridLayout gap={{
                                                    cols: 0,
                                                    row: 6
                                                }}
                                                    className={highlightedPoles && highlightedPoles.length > 0 ? "pulse-map-streetview-searchbox-container-querymap" : "pulse-map-streetview-searchbox-container"}
                                                >
                                                    <GridLayoutItem className="box rect" col={1} row={1}>
                                                        <DropDownList
                                                            id="genre"
                                                            className="pulse-map-streetview-searchbox-dropdown"
                                                            data={mapSearchOption}
                                                            value={this.state.searchType}
                                                            onChange={(e) => this.handleSearchTypeChange(e)}
                                                        />
                                                    </GridLayoutItem>
                                                    <GridLayoutItem className="box" col={2} row={1}>
                                                        {this.state.searchType === "Structure ID" ?
                                                            <input
                                                                onKeyUp={(e) => this.handleStreetviewKeyPress(e)}
                                                                type="text"
                                                                placeholder="Search Maps"
                                                                className="pulse-map-streetview-searchbox-input"

                                                            /> :
                                                            <Autocomplete
                                                                onLoad={this.onLoad}
                                                                onPlaceChanged={this.onPlaceChanged}
                                                            >
                                                                <input
                                                                    type="text"
                                                                    placeholder="Search Maps"
                                                                    className={this.state.addressValid ? "pulse-map-streetview-searchbox-input" : "pulse-map-streetview-searchbox-input pulse-map-streetview-searchbox-input-error"}
                                                                    //valid={this.state.addressValid}
                                                                    onKeyUp={(e) => this.handleStreetviewAddressKeyPress(e)}
                                                                />
                                                            </Autocomplete>
                                                        }
                                                    </GridLayoutItem>
                                                    <GridLayoutItem className="box rect parent" col={3} row={1} >
                                                        {this.state.addressValid ? null :
                                                            <span className="pulse-input-icon">
                                                                <img
                                                                    src={validationIcon}
                                                                    alt="Warning"
                                                                    className="pulse-address-search-warning-icon"
                                                                    onMouseDown={(e) => e.target.style.transform = 'scale(0.9)'} // Visual feedback
                                                                    onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                                                                    onClick={() => this.handleWarningIconClick()}
                                                                />
                                                            </span>
                                                        }
                                                    </GridLayoutItem>

                                                    <GridLayoutItem className="box rect" col={1} row={2} colSpan={2}>
                                                        {
                                                            this.state.showErrorMessage ?
                                                                <div className="white-box"  ref={this.wrapperRef} >
                                                                    <h2 className="box-header">Maps cannot find {this.state.searchEnteredAddress}.</h2>
                                                                    <p className="box-content">
                                                                        Make sure your search is spelled correctly.Try adding a city, state, or zip code.
                                                        </p>
                                                                </div> : null
                                                        }
                                                    </GridLayoutItem>
                                                </GridLayout>
                                            <Button rounded={"full"} fillMode={"solid"} svgIcon={xIcon} themeColor={"secondary"} className='nimbly-streetview-close-button' onClick={() => {this.panoramaInstance.setVisible(false)}} />
                                            <Button fillMode={"solid"} svgIcon={plusIcon} themeColor={"secondary"} className='nimbly-streetview-plus-zoom-button' onClick={() => this.handleStreetViewZoomChange(this.panoramaInstance, 0.25)} />
                                            <Button fillMode={"solid"} svgIcon={minusIcon} themeColor={"secondary"} className='nimbly-streetview-minus-zoom-button' onClick={() => this.handleStreetViewZoomChange(this.panoramaInstance, -0.25)} />
                                            { this.state.showStreetviewPoleMenu ?
                                                <>
                                                    <button className="protruding-btn protruding-close-btn" onClick={() => this.setState({ showStreetviewPoleMenu: false })}>
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M15 6l-8 6 8 6V6z" />
                                                        </svg>
                                                    </button> 
                                                    <ExpandedUGStreetViewPole item={this.state.currentStreetViewSelectedPole} closePopup={() => this.setState({ showStreetviewPoleMenu: false, currentStreetViewSelectedPole: null })}
                                                    />
                                                </>
                                                :
                                                <>
                                                    <div className="streetview-address-overlay">
                                                        <Button fillMode={"solid"} themeColor={"secondary"} className="nimbly-streetview-back-button" onClick={() => {this.panoramaInstance.setVisible(false)}}>
                                                            <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none">
                                                                <line x1="19" y1="12" x2="5" y2="12"></line>
                                                                <polyline points="12 19 5 12 12 5"></polyline>
                                                            </svg>
                                                        </Button>
                                                        
                                                        <div className="nimbly-streetview-address-text-group">
                                                            <span className="nimbly-streetview-address-street-line">{ this.state.currentAddress }</span>
                                                            <span className="nimbly-streetview-address-city-line">{ this.state.currentCity }</span>
                                                        </div>
                                                    </div>
                                                    <button className="protruding-btn protruding-open-btn" onClick={() => this.setState({ showStreetviewPoleMenu: true })}>
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M9 6l8 6-8 6V6z" />
                                                        </svg>
                                                    </button>
                                                </>
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                        )}
            </>
        );
    }

    async populateMapData(rawQuery) {
        const { selectedProject, GCP_Project, Dataset_ID } = this.props.projectContext;
        const { environmentConfig } = this.props.environmentConfigContext;
        let markerListUG = [];
        let markerListPole = [];

        const payload = {
            Dataset_ID: Dataset_ID,
            GCP_Project: GCP_Project,
            Project: selectedProject,
            Location: {
                ColumnName: "Coordinates",
                TableName: "Location_Details",
            },
            Search: {
                ColumnName: "Address",
                TableName: "Location_Details",
            },
            UniqueID: {
                ColumnName: "GlobalID",
                TableName: "Poles",
            },
            Category: {
                ColumnName: "Symbology",
                TableName: "Poles",
            },
            Type: {
                ColumnName: "Type",
                TableName: "Poles",
            },
            AuditDate: {
                ColumnName: "Audit Date",
                TableName: "Poles",
            },
            RejectPole: {
                ColumnName: "Reject Pole",
                TableName: "Poles",
            },
            NonRestorableRejectStatus: {
                ColumnName: "Non Restorable Reject Status",
                TableName: "Poles",
            },
            RestorableRejectStatus: {
                ColumnName: "Restorable Reject Status",
                TableName: "Poles",
            },
            StructureID: {
                ColumnName: "Structure ID",
                TableName: "Poles",
            }
        };

        const payload_UG = {
            Dataset_ID: Dataset_ID,
            GCP_Project: GCP_Project,
            Project: selectedProject,
            Location: {
                ColumnName: "Coordinates",
                TableName: "Location_Details",
            },
            Search: {
                ColumnName: "Address",
                TableName: "Location_Details",
            },
            UniqueID: {
                ColumnName: "GlobalID",
                TableName: "Underground",
            },
            Category: {
                ColumnName: "Symbology",
                TableName: "Underground",
            },
            Type: {
                ColumnName: "TYPE",
                TableName: "Underground",
            },
            IntInspection: {
                ColumnName: "Enclosure External Inspection",
                TableName: "Underground",
            },
            ExtInspection: {
                ColumnName: "Enclosure Internal Inspection",
                TableName: "Underground",
            },
            Rejects: {
                ColumnName: "Reject Status",
                TableName: "Underground",
            },
            StructureID: {
                ColumnName: "Structure ID",
                TableName: "Underground",
            },
            StructureType: { 
                TableName: "Underground", 
                ColumnName: "Structure Type", 
            }
        };

        this.setState({ loading: true });

        fetch(`${process.env.REACT_APP_WEB_API_URL}/api-common/poles/GetBriefPoles`, {
            method: 'POST',
            headers: {
                'frontendenvironmentconfig': environmentConfig,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((data) => {
                // reformat poles
                markerListPole = data.map(pole => {
                    let arr = pole.Location.split("-");
                    if (arr.length === 2) {
                        let lat = Number(arr[0]);
                        let lng = -(Number(arr[1]));

                        const markerData = {
                            coords: { lat, lng },
                            info: {
                                GlobalID: pole.GlobalID,
                                Address: pole.Search || null,
                                Type: pole.Type,
                                StructureID: pole.StructureID,
                                Audit_Date: pole.AuditDate || null,          
                                SymbologyKey: pole.SymbologyKey || null
                            },
                            highlighted: this.props.highlightedPolesContext.highlightedPoles.includes(pole.GlobalID),
                        }
                        return {
                            ...markerData,
                            iconSymbol: this.assignPoleSymbologyColor(markerData),
                        };
                    }
                    return null;
                }).filter(Boolean);


                // fetch ug              
                fetch(`${process.env.REACT_APP_WEB_API_URL}/api-common/poles/GetBriefUGPoles`, {
                    method: 'POST',
                    headers: {
                        'frontendenvironmentconfig': environmentConfig,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload_UG),
                })
                    .then((res) => res.json())
                    .then((data) => {
                        // reformat poles
                        markerListUG = data.map(pole => {
                            let arr = pole.Location.split("-");
                            if (arr.length === 2) {
                                let lat = Number(arr[0]);
                                let lng = -(Number(arr[1]));

                                const markerData = {
                                    coords: { lat, lng },
                                    info: {
                                        GlobalID: pole.GlobalID,
                                        Audit_Date: pole.Category,
                                        Address: pole.Search === " " ? null : pole.Search,
                                        Type: pole.Type,
                                        IntInspection: pole.IntInspection,
                                        ExtInspection: pole.ExtInspection,
                                        Rejects: pole.Rejects,
                                        StructureID: pole.StructureID,
                                        StructureType: pole.StructureType
                                    },
                                    highlighted: this.props.highlightedPolesContext.highlightedPoles.includes(pole.GlobalID),
                                }
                                return {
                                    ...markerData,
                                    iconSymbol: this.assignPoleSymbologyColor(markerData),
                                };
                            }
                            return null;
                        }).filter(Boolean);
                        this.handleMapIntLoad(markerListPole, markerListUG)
                        })
                        .catch(() => this.handleMapIntLoad(markerListPole, markerListUG));


                        })
            .catch(() => this.setState({ loading: false }));


}

    handleMapIntLoad = (markerListPole, markerListUG) => {
        const markerList = markerListPole.concat(markerListUG);
        this.setState({
            mapData: markerList,
            filteredMapData: [],
            currentCenter: markerList[markerList.length-1]?.coords || { lat: 0, lng: 0 },
            counts: markerList.length,
            loading: false,
        });
    }
}

export default withEnvironmentConfig(withProject(withHighlightedPoles(withTabContext(RSPoleMap))));